import { useState, useEffect } from 'react';
import { getLatestPosts, Post } from '../../lib/directus';

// Загружает только последние опубликованные новости, запрашивая у Directus
// ровно `limit` записей без поля `content`.
export const useLatestPosts = (limit: number = 3) => {
  const [posts, setPosts] = useState<Post[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;

    const fetchLatestPosts = async () => {
      try {
        setLoading(true);
        const latest = await getLatestPosts(limit);
        if (cancelled) return;
        setPosts(latest);
        setError(null);
      } catch (err) {
        console.error('Ошибка загрузки последних новостей:', err);
        if (!cancelled) setError('Не удалось загрузить новости');
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    fetchLatestPosts();

    return () => {
      cancelled = true;
    };
  }, [limit]);

  return { posts, loading, error };
};
